import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-109wda0-0"
})(["width:100%;max-width:", ";padding:0 30px;margin:0 auto;", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.maxWidth;
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 0 24px;\n  "]))), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0 15px;\n  "]))));